import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Column, Icon, Row, VideoModal } from '@pella/sash-framework';
import { CTA, Image } from '../../';
import { initDataLayer } from '../../utilities/functions';
import { isValidArray } from '../../utilities/validations';
import styles from './index.module.scss';

const BaseCard = ({ data, children, className, layout, params, noLink = false, ...other }) => {
	const [videoOpen, setVideoOpen] = useState(false);

	const onPlayClick = () => {
		setVideoOpen(true);
		initDataLayer('videoplay');
	};

	const renderCard = () => (
		<Row
			noGutters={layout !== 'horizontal'}
			reverse={layout === 'horizontal' ? true : false}
		>
			<Column
				xs={12}
				lg={layout === 'horizontal' ? 6 : 12}
			>
				{data?.image && (
					<Image
						data={isValidArray(data.image) ? data.image[0] : data.image}
						className={`sash-Card-CardImage ${styles.card_CardImage}`}
						params={params}
					/>
				)}

				{isValidArray(data?.video) && (
					<button
						onClick={() => onPlayClick()}
						className={`sash-Card-CardPlayButton ${styles.card_CardPlayButton}`}
					>
						<span className={styles.srOnly}>Watch the Video</span>
						<Icon
							name='play_circle'
							className={styles.card_CardPlayIcon}
						/>
					</button>
				)}
			</Column>

			<Column
				xs={12}
				lg={layout === 'horizontal' ? 6 : 12}
			>
				<div className={`sash-Card-CardBody ${styles.card_CardBody}`}>
					{data?.heading && <h3>{data.heading}</h3>}
					{data?.description && (
						<div
							dangerouslySetInnerHTML={{
								__html: data.description,
							}}
						/>
					)}
					{children}
				</div>
			</Column>
		</Row>
	);

	return (
		<div
			className={`sash-Card ${styles.card} ${layout === 'horizontal' ? styles.card_horizontal : ''} ${className || ''}`}
			data-testid='card'
			{...other}
		>
			{!noLink && isValidArray(data?.ctas) && (
				<CTA
					data={data.ctas[0]}
					className={styles.card_Link}
					renderAs='link'
				>
					{renderCard()}
				</CTA>
			)}

			{(noLink || !data?.ctas?.[0]) && renderCard()}

			{data?.video?.[0] && (
				<VideoModal
					videoId={data.video[0].video.video_id}
					title={data.video[0].video.title}
					transcript={data.video[0].transcript}
					isOpen={videoOpen}
					onClose={() => setVideoOpen(false)}
				/>
			)}
		</div>
	);
};

BaseCard.propTypes = {
	data: PropTypes.object,
	children: PropTypes.node,
	className: PropTypes.string,
	layout: PropTypes.string,
	params: PropTypes.string,
	noLink: PropTypes.bool,
};

export default BaseCard;
